.sessionHeaderContainer {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	width: 100%;
	padding: 0.625rem;
	box-sizing: border-box;
	background: linear-gradient(135deg, #fafbff 0%, #ffffff 100%);
	border-radius: inherit;
}

.sessionDetailsRow {
	display: flex;
	flex-direction: row;
	width: 100%;
	flex-wrap: wrap;
	gap: 0.625rem;
}

.sessionInfoCard {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	border: 1px solid #e5e7eb;
	background-color: #fff;
	border-radius: 8px;
	padding: 0.875rem;
	box-sizing: border-box;

	.sessionInfoTextCol {
		display: flex;
		flex-direction: column;
		gap: 0.25rem;

		& .title {
			font-weight: 400;
			font-size: 0.875rem;
			line-height: 1.6;
			color: #6a7282;
		}

		& .description {
			color: #0a0a0a;
			font-weight: 400;
			font-size: 0.9375rem;
			line-height: 1.5;
			letter-spacing: -0.15px;
		}
	}
}

.sessionHeaderControls {
	display: flex;
	align-items: center;
	gap: 1.25rem;
}

.nameField:global(.MuiTextField-root) {
	flex: 1;

	& :global(.MuiOutlinedInput-root) {
		margin: 0.125rem;
	}
}

.headerRow {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	gap: 0.25rem;
}

.nameWrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.625rem;
	width: 100%;
}

.sessionNumContainer {
	width: 36px;
	height: 36px;
	border: 1px solid #9288cb;
	background: #fefdff;
	box-shadow: 0px 1px 2px -1px #0000001a;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;

	& :global(.MuiTypography-root) {
		color: #42296e;
		font-weight: 700;
		font-size: 0.9375rem;
		line-height: 1.5;
		letter-spacing: -0.23px;
	}
}

.sessionExpandButton:global(.MuiButton-root) {
	background-color: #f3f4f6;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
	height: 42px;
	width: 42px;
	padding: 0;

	& svg {
		color: #535353;
	}
}

@media (max-width: 768px) {
	.sessionExpandButton:global(.MuiButton-root) {
		height: 36px;
		width: 36px;
		padding: 0 !important;
	}

	.headerRow {
		flex-wrap: wrap; /* Allows items to wrap to a new line */
		gap: 0.5rem;
		align-items: center;
	}

	.sessionNumContainer {
		order: 1; /* Stay first */
	}

	.sessionHeaderControls {
		order: 2; /* Move to the right of the number */
		gap: 0.25rem;
	}

	.sessionName:global(.MuiTypography-root) {
		order: 3; /* Move to the bottom row */
		flex: 0 0 100%; /* Force it to take up the full width of the new row */
		font-weight: 600;
		font-size: 0.9375rem;
	}

	.sessionInfoCard {
		width: 100%;
	}
}
